import { Page } from '@/components';
import AtRiskTable from './AtRiskTable';
import IlkCompositionDonutChart from './IlkCompositionDonutChart';
import CdpCompositionDonutChart from './CdpCompositionDonutChart';
import OsmKpis from './OsmKpis';
import { Flex, Heading } from '@blockanalitica/ui';
import DebtAtRiskGraph from './DebtAtRiskGraph';
import { useApi } from '@/api';
import { PageSkeleton } from '@/components';
import { KpiCard } from '@/components';

export default function CdpsAtRisk() {
  const [data, error] = useApi({ url: '/at-risk/' });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page title="CDPs at Risk">
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard title="CDPs at Risk" data={data} field="number_of_cdps" />
          <KpiCard
            title="Total Debt at Risk"
            data={data}
            field="debt_at_risk"
            options={{
              currency: 'DAI'
            }}
          />
        </Flex>
        {data.debt_at_risk && (
          <>
            <DebtAtRiskGraph />
            <OsmKpis />
          </>
        )}

        <AtRiskTable />
        {data.debt_at_risk && (
          <>
            <Flex
              flexBasis="100%"
              flexDirection={['column', 'row']}
              alignItems="center">
              <Flex
                gap={['m', 's']}
                flexDirection="column"
                width={['100%', '50%']}
                alignItems="center">
                <Heading size="3">Ilk Debt Composition</Heading>
                <IlkCompositionDonutChart />
              </Flex>
              <Flex
                gap={['m', 's']}
                flexDirection="column"
                width={['100%', '50%']}
                alignItems="center">
                <Heading size="3">CDP Debt Composition</Heading>
                <CdpCompositionDonutChart />
              </Flex>
            </Flex>
          </>
        )}
      </Page>
    );
  }
  return <PageSkeleton />;
}
